export enum LogLevelEnum {
  DEBUG,
  LOG,
  WARN,
  ERROR,
  CRITICAL,
}

export class LogLevel {
  public level: LogLevelEnum;

  constructor(level: LogLevelEnum) {
    this.level = level;
  }

  isActive(configLevel: LogLevel) {
    return configLevel.level <= this.level;
  }

  static fromString(
    level: "DEBUG" | "LOG" | "WARN" | "ERROR" | "CRITICAL",
  ): LogLevelEnum {
    if (LogLevelEnum[level] === undefined) {
      throw new Error(`invalid log level ${level}`);
    }
    return LogLevelEnum[level];
  }

  toString() {
    switch (this.level) {
      case LogLevelEnum.DEBUG:
        return "DEBUG";
      case LogLevelEnum.LOG:
        return "LOG";
      case LogLevelEnum.WARN:
        return "WARN";
      case LogLevelEnum.ERROR:
        return "ERROR";
      case LogLevelEnum.CRITICAL:
        return "CRITICAL";
      default:
        throw new Error("invalid log level");
    }
  }

  static get debug() {
    return new LogLevel(LogLevelEnum.DEBUG);
  }

  static get log() {
    return new LogLevel(LogLevelEnum.LOG);
  }

  static get warn() {
    return new LogLevel(LogLevelEnum.WARN);
  }

  static get error() {
    return new LogLevel(LogLevelEnum.ERROR);
  }

  static get critical() {
    return new LogLevel(LogLevelEnum.CRITICAL);
  }
}

export interface LoggerInterface {
  debug(
    message: string,
    tags: string[],
    logData?: { [key: string]: unknown },
  ): Promise<boolean>;
  log(
    message: string,
    tags: string[],
    logData?: { [key: string]: unknown },
  ): Promise<boolean>;
  warn(
    message: string,
    tags: string[],
    logData?: { [key: string]: unknown },
  ): Promise<boolean>;
  error(
    message: string,
    tags: string[],
    logData?: { [key: string]: unknown },
  ): Promise<boolean>;
  critical(
    message: string,
    tags: string[],
    logData?: { [key: string]: unknown },
  ): Promise<boolean>;
}

export type LogTag = string;
export interface LogData {
  [key: string]: any;
}
export interface LogDocument {
  level: LogLevel;
  timestamp: Date;
  deviceId: string;
  version: string;
  family: string;
  env: string;
  deviceInfo: string;
  logMessage: string;
  logData: LogData;
  logTags?: LogTag[];
}

export interface LogTransportInterface {
  logDocument(doc: LogDocument): Promise<boolean>;
}

export interface LoggerOptions {
  configLevel: LogLevelEnum;
  transports: LogTransportInterface[];
  env: string;
  family: string;
  deviceId: string;
  deviceInfo: string;
}
